export const TIKTOK = 'tiktok_pixel_api';
export const ENHANCED_CONVERSIONS = 'google_enhanced_conversions';
export const LINE_POINTS = 'line_point_cpa_tag';
